// extracted by mini-css-extract-plugin
module.exports = {"about":"styles_about_2VA8HJFWVeo8wxzgEAwuAn"};